import { forwardRef, memo } from 'react'
import { Box } from '@mui/material'
import { Virtuoso } from 'react-virtuoso'
import { withErrorBoundary } from '@/components/Utils'
import { virtualListClasses } from './VirtualList.data'
import { VirtualListProps } from './VirtualList.types'

const getComponents = <D, C>(): VirtualListProps<D, C>['components'] => ({
  List: ListWrapper,
})

function VirtualList<D, C>(props: VirtualListProps<D, C>) {
  const { className = '', ...otherProps } = props
  return (
    <Virtuoso
      className={`${className} h-100`}
      increaseViewportBy={{ top: 100, bottom: 100 }}
      {...otherProps}
      components={getComponents<D, C>()}
    />
  )
}

const ListWrapper = forwardRef<
  HTMLDivElement,
  { style?: React.CSSProperties; children?: React.ReactNode }
>(({ style, children }, listRef) => (
  <Box className={virtualListClasses.list} style={{ ...style }} component="div" ref={listRef}>
    {children}
  </Box>
))
ListWrapper.displayName = 'ListWrapper'

export default memo(withErrorBoundary(VirtualList)) as unknown as typeof VirtualList
